document.querySelectorAll("[data-video-container]").forEach(function (wrapper) {
    const overlay = wrapper.querySelector("[data-play-toggle]");
    const iframe = wrapper.querySelector("iframe");
    const playButton = wrapper.querySelector(".play-btn");

    let isPlaying = false;

    function playVideo() {
        if (iframe) {
            let src = iframe.getAttribute("src") || "";
            if (!src.includes("autoplay=1")) {
                const separator = src.includes("?") ? "&" : "?";
                iframe.setAttribute("src", src + separator + "autoplay=1");
            }
        }
        overlay.classList.add("hidden");
        wrapper.classList.add("playing");
        isPlaying = true;
    }

    function pauseVideo() {
        overlay.classList.remove("hidden");
        wrapper.classList.remove("playing");
        isPlaying = false;
    }

    function togglePlay(e) {
        e.preventDefault();
        isPlaying ? pauseVideo() : playVideo();
    }

    if (overlay) overlay.addEventListener("click", togglePlay);
    if (playButton) playButton.addEventListener("click", togglePlay);
});